import classNames from 'classnames';
import {useNavigate} from 'react-router-dom';
const MainItem = ({icon, isActive, title, isFarm, router}: IMainItemProps) => {
  const navigate = useNavigate();
  return (
    <>
      <i
        onClick={() =>
          isActive
            ? isFarm
              ? navigate('/farm/home')
              : navigate('/wholesaler/home')
            : navigate(router)
        }
        className={classNames(
          'absolute bottom-10 text-white bg-primary  rounded-full',
          isActive ? 'icon-close py-6 px-6' : `${icon} py-4 px-5 text-3xl`,
        )}
      />

      <small
        className={classNames(
          ' font-extrabold text-gray-2 mt-8',
          isActive && 'text-primary',
        )}
      >
        {title}
      </small>
    </>
  );
};

export default MainItem;
